import { NgTemplateOutlet } from '@angular/common'
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { Toast } from 'ngx-toastr'
import { ToastDisplayComponent } from './toast-display'
import { ToastPayload } from './toast.service'

/** This is a “glue” component between the ngx-toastr package and {@link ToastDisplayComponent} */
@Component({
  selector: '[ftr-toast]',
  template: `
    <ftr-toast-display
      [type]="payload.type"
      [message]="message()"
      [title]="title()"
      [hideClose]="payload.hideClose ?? false"
      (closeToast)="handleClose()"
    >
      @if (payload.iconTemplate) {
        <ng-template #iconTemplate>
          <ng-container *ngTemplateOutlet="payload.iconTemplate" />
        </ng-template>
      }
      @if (payload.messageTemplate) {
        <ng-template #messageTemplate>
          <ng-container *ngTemplateOutlet="payload.messageTemplate; context: { $implicit: this }" />
        </ng-template>
      }
    </ftr-toast-display>
  `,
  styleUrl: './toast.component.css',
  imports: [NgTemplateOutlet, ToastDisplayComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class ToastComponent extends Toast {
  get payload(): ToastPayload {
    return this.options().payload as ToastPayload
  }

  protected handleClose(): void {
    const onClose = this.payload.onClose
    if (onClose) {
      onClose()
    } else {
      this.remove()
    }
  }
}
